import { useNavigate } from "react-router-dom";
import { useReveal } from "../hooks/useReveal";
import "./WhyUs.css";

export default function WhyUs({ data }) {
  const nav = useNavigate();
  const go = (page) => nav(page === "home" ? "/" : `/${page}`);
  const r1 = useReveal(), r2 = useReveal(), r3 = useReveal();

  return (
    <div className="wy">

      {/* HERO */}
      <section className="wy-hero">
        <div className="wy-hero-inner wrap">
          <div>
            <span className="wy-hero-tag">{data?.hero?.tag}</span>
            <h1 className="wy-hero-h1">
              {data?.hero?.h1?.map((line,i)=>(
                <span key={i} className={line===data?.hero?.italic?"italic":""}>{line}<br/></span>
              ))}
            </h1>
          </div>
          <div>
            <p className="wy-hero-p">{data?.hero?.body}</p>
          </div>
        </div>
      </section>

      {/* FOUR PILLARS */}
      <section className="wy-pillars" ref={r1}>
        <div className="wy-pillars-grid wrap">
          {data?.pillars?.map((p,i)=>(
            <div className="wy-pillar rv" key={i}>
              <div className="wy-pillar-ico">{p.icon}</div>
              <div className="wy-pillar-num">{p.num}</div>
              <h3 className="wy-pillar-title">{p.title}</h3>
              <p className="wy-pillar-body">{p.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* VS OTHERS TABLE */}
      <section className="wy-vs" ref={r2}>
        <div className="wy-vs-inner wrap">
          <div className="wy-vs-hd">
            <span className="wy-vs-tag rv">{data?.vsOthers?.tag}</span>
            <h2 className="wy-vs-h2 rv">{data?.vsOthers?.h2}</h2>
          </div>
          <div className="wy-vs-table rv">
            <div className="wy-vs-thead">
              <span>Attribute</span>
              <span className="wy-us-col">PR Elite Estate</span>
              <span>Traditional Broker</span>
            </div>
            {data?.vsOthers?.rows?.map((row,i)=>(
              <div className="wy-vs-row" key={i}>
                <span className="wy-vs-attr">{row.attr}</span>
                <span className="wy-vs-us">{row.us}</span>
                <span className="wy-vs-them">{row.them}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="wy-cta" ref={r3}>
        <div className="wy-cta-inner">
          <h2 className="wy-cta-h2 rv">{data?.cta?.h2}</h2>
          <p className="wy-cta-p rv">{data?.cta?.body}</p>
          <button className="btn btn-r rv" onClick={()=>go(data?.cta?.cta?.page)}>{data?.cta?.cta?.label}</button>
        </div>
      </section>

    </div>
  );
}
